import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IPosition } from '../models/position';
import { IPositionContact } from '../models/position';
import { ErrorService } from '../helpers/errorService';
import { EEopTemplates } from '../models/eop_types.enum';

@Injectable({
  providedIn: 'root'
})
export class PositionsService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getPositions(eopTemplateId: EEopTemplates, orgType?: string): Observable<{has_error: boolean, message: string, data: IPosition[]}> {
    const url = environment.apiBaseUrl + endpoints.positions.replace(':eopTemplateId', eopTemplateId.toString());
    let params = new HttpParams();
    if (orgType) {
      params = params.set('orgType', orgType);
    }

    return this.http.get<{has_error: boolean, message: string, data: IPosition[]}>(url, { params }).pipe(
      catchError(this.errorService.handleError)
    );
  };

  getPositionContacts(buildingId: string, eopTemplateId: EEopTemplates): Observable<{has_error: boolean, message: string, data: IPositionContact[]}> {
    const url = environment.apiBaseUrl + endpoints.positionContact.replace(':buildingId', buildingId).replace(':eopTemplateId', eopTemplateId.toString());;
    return this.http.get<{has_error: boolean, message: string, data: IPositionContact[]}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  };

  savePositionContacts(buildingId: string, contactData: IPositionContact[]): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.savePositionContacts.replace(':buildingId', buildingId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, contactData).pipe(
      catchError(this.errorService.handleError)
    );
  }

  deleteAllPositionContacts(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.deleteAllPositionContacts.replace(':buildingId', buildingId);
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }
}